module.exports = __webpack_public_path__ + "d0d161cc8e89295372b6bdfde0976631.png";